import { AdvertTitle } from '../value-objects/AdvertTitle';
import { AdvertAttachmentsService } from '../services/AdvertAttachmentsService';

export interface AttachmentProps {
  uuid?: string;
  url: string;
  type: 'image' | 'video' | 'other';
  position: number;
}

export interface AdvertProps {
  uuid: string;
  id: number;
  title: AdvertTitle;
  description: string;
  accountId: number;
  createdAt: Date;
  updatedAt: Date;
  attachments: AttachmentProps[];
}

export class AdvertEntity {
  private readonly props: AdvertProps;
  private constructor(props: AdvertProps) { this.props = { ...props, attachments: [...props.attachments] }; }
  static create(props: AdvertProps): AdvertEntity {
    if ((props.attachments || []).length > 10) {
      throw new Error('advert-files-limit-exceeded');
    }
    return new AdvertEntity(props);
  }
  get uuid() { return this.props.uuid; }
  get id() { return this.props.id; }
  get title() { return this.props.title; }
  get description() { return this.props.description; }
  get accountId() { return this.props.accountId; }
  get createdAt() { return this.props.createdAt; }
  get updatedAt() { return this.props.updatedAt; }
  get attachments() { return [...this.props.attachments].sort((a,b)=>a.position-b.position); }
  withTitle(newTitle: AdvertTitle): AdvertEntity { return new AdvertEntity({ ...this.props, title: newTitle }); }
  withDescription(desc: string): AdvertEntity { return new AdvertEntity({ ...this.props, description: desc }); }
  withAttachments(atts: AttachmentProps[]): AdvertEntity {
    if ((atts || []).length > 10) {
      throw new Error('advert-files-limit-exceeded');
    }
    return new AdvertEntity({ ...this.props, attachments: [...atts] });
  }
  addAttachment(att: AttachmentProps): AdvertEntity {
    const next = AdvertAttachmentsService.add(this.attachments, att as any);
    return this.withAttachments(next);
  }
  removeAttachment(att: AttachmentProps): AdvertEntity {
    const key = att.uuid ? att.uuid : att.url;
    const filtered = AdvertAttachmentsService.remove(this.attachments, key);
    const reordered = AdvertAttachmentsService.reorder(filtered);
    return this.withAttachments(reordered);
  }
  reorderAttachments(atts: AttachmentProps[]): AdvertEntity {
    const reordered = AdvertAttachmentsService.reorder(atts);
    return this.withAttachments(reordered);
  }
}
